module.exports = __webpack_public_path__ + "a7a426bc680bf7712d17ea529a29b2de.ttf";